// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// customNoteSave (#349) — the on-blur decision for a Custom availability note,
// for BOTH CrewDetailModal tabs (Availability and Availability Defaults).
//
// Pure + importable so the test exercises the exact logic the modal runs. The
// bug this pins: the Defaults branch of saveCustomStatus read the DEFAULTS text
// box to decide whether to save, but passed the AVAILABILITY text box as the
// value — harmless for two years (the defaults save reads its own array), until
// #328 added an early-return in onChangeStatus that bails when the passed text
// is empty. On the Defaults tab that text was always empty, so the note silently
// never saved. The invariant this function guarantees: **the value tested and
// the value passed on come from the SAME tab's array.**
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

/**
 * Decide what a Custom-note text box's blur should do.
 *
 * @param {object} o
 * @param {string} o.currentText   the value in THIS tab's text box for the day
 * @param {string} o.savedCustom   the day's currently-saved custom text ("" if none)
 * @returns {{ action: "none" } | { action: "saveCustom", text: string } | { action: "clear" }}
 *   - "none"       — unchanged; do nothing (no redundant write)
 *   - "saveCustom" — persist this text as a Custom note (text is non-empty)
 *   - "clear"      — the box was emptied; revert the day to Available
 */
export function decideCustomNoteSave({ currentText, savedCustom }) {
  const text = currentText ?? "";
  const saved = savedCustom ?? "";
  if (text === saved) return { action: "none" };
  if (text) return { action: "saveCustom", text };
  return { action: "clear" };
}
